<template>
  <base-dialog
    :action="onAction"
    :action-name="'Delete'"
    :close="onClose"
    :title="'Delete User'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <div>
        <p>
          What would you like to do with pending tasks if any are assigned to this user?

          << options >>
          <br>
          <b>Are you sure you want to delete this user?</b>
        </p>
      </div>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"

export default {
  components: { BaseDialog },
  props: {
    id: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      name: ''
    }
  },
  methods:{
    ...mapActions(['deleteTenantUser']),
    onClose(){
      this.$emit('close')
    },
    async onAction() {
      const payload = {
        id: this.id,
      }

      await this.deleteTenantUser(payload)

      this.$emit('action', payload)
    }
  }
}
</script>
